<template>
  <div>
    <el-card>
      <div slot="header" class="clearfix">
        <span style="color: #409EFF">银行卡管理</span>
      </div>
      <el-row :gutter="20">
        <el-col :span="24" align="center">
          <el-card class="box-card">
            <el-button style="background-color: #acacac;width: 16rem;height: 9rem;" @click="handleAdd('添加银行卡')">
              <i class="el-icon-plus"></i>
              <div style="margin-top: 10px">
                <span>添加银行卡</span>
              </div>
            </el-button>
          </el-card>
          <el-row :gutter="20" v-for="(item, index) in cardData" :key="index" style="margin-top: 20px;">
            <el-col :span="24">
              <el-card class="box-card" style="position: relative;" @mouseenter.native="onMouseOver(item)"
                       @mouseleave.native="onMouseOut(item)">
                <el-row :gutter="5" style="margin-top: 5px;">
                  <el-col :span="12">
                    <div style="display: flex;justify-content: center;line-height: 40px;">
                      <el-avatar size="small" :src="item.backIcon"></el-avatar>
                      <div style="margin-left: 5px;line-height: 30px;">{{ item.backName }}</div>
                    </div>
                  </el-col>
                  <el-col :span="10" :offset="2">
                    <span style="margin-left: 5px;line-height: 30px;">尾号{{ item.backCardNum | getCardEndNumbers}}</span>
                  </el-col>
                </el-row>
                <el-row :gutter="40" style="margin-left: 1px; margin-top: 10%;text-align: left;">
                  <el-col :span="20">
                    <div>{{ item.backCardName }}</div>
                    <span style="color: forestgreen; font-weight: normal;font-size: small">{{ item.status ? "审核通过":"审核未通过"}}</span>
                  </el-col>
                </el-row>
                <el-row :gutter="2" style="margin-top: 2%" v-show="item.isShow">
                  <el-col :span="8">
                    <el-button type="text" style="color: red; font-weight: normal;font-size: small;" @click="setDefault(item)">设为默认</el-button>
                  </el-col>
                  <el-col :span="6" :offset="4">
                    <el-button type="text" style="color: red; font-weight: normal;font-size: small;" @click="handleEdit(item.id, item, '修改银行卡')">编辑</el-button>
                  </el-col>
                  <el-col :span="4">
                    <el-button type="text" style="color: red; font-weight: normal;font-size: small;" @click="deleteData(item)">删除</el-button>
                  </el-col>
                </el-row>
              </el-card>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </el-card>
    <el-dialog :title="dialogTitle"
               :visible.sync="dialogFormVisible"
               :before-close="beforeDialogClose"
               style="text-align: center">
      <el-form ref="dialogForm" :model="dialogForm" label-width="260px">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-select v-model="dialogForm.backName" clearable placeholder="请选择银行" style="width: 80%">
              <el-option
                  v-for="item in backOptions"
                  :key="item.id"
                  :label="item.backName"
                  :value="item.backName"
              >
              </el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-input v-model="dialogForm.backName" placeholder="开户行(非必填)"
                      style="width: 80%;margin-top: 20px"></el-input>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-input v-model="dialogForm.backCardName" placeholder="开户人姓名"
                      style="width: 80%;margin-top: 20px"></el-input>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-input type="text" onkeyup="this.value=this.value.replace(/[^\w_.@]/g,'');" v-model="dialogForm.backCardNum" placeholder="支付账号信息" style="width: 80%;margin-top: 20px"></el-input>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="submitDialogForm()" size="mini" type="primary">提交</el-button>
        <el-button @click="handleCloseDialog" size="mini">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import MixinCUD from "../../components/MixinCUD";
import {
  addB2cBackCard, deleteB2cBackCard,
  getAllB2cBackCard,
  getAllB2cBackInfos,
  updateB2cBackCard
} from "../../api/b2cbusiness/b2c_backcardmanage";

export default {
  name: "SalemanBackBindManage",
  mixins: [MixinCUD],
  data() {
    return {
      cardData: [
        {
          backName: "招商银行",
          backCardName: "陈哲艺",
          backCardNum: "21212121129693",
          backIcon: 'iconfont icon-zhaoshangyinhang',
          status: "审核通过",
          isDefault: "true",
          isShow: false,
        },
        {
          backName: "招商银行",
          backCardName: "陈哲艺",
          backCardNum: "213232339693",
          backIcon: 'iconfont icon-zhaoshangyinhang',
          status: "审核通过",
          isDefault: "true",
          isShow: false,
        }
      ],
      queryForm: {
        reciverMoneyType: "银行卡",
        accountNumber: "6215686300004271725",
        accountName: "王毅",
        openAccountBack: "中国银行 徐州支行",
        payBack: "",
        investMoney: ""
      },
      backOptions:[],
      dialogFormVisible: false,
      dialogTitle: "",
      dialogRefName: "dialogForm",
      dialogForm:{

      }
    }
  },
  mounted() {
    this.getAllBackInfos();
    getAllB2cBackCard().then(res=>{
      console.log(res.data);
      if (res.success){
        this.setData(res.data);
      }
    });
  },
  filters:{
    getCardEndNumbers:function (val) {
      return val.substring(val.length-4);
    }
  },
  methods: {
    getAllBackInfos(){
      getAllB2cBackInfos().then(res=>{
        console.log(res.data);
        if (res.success){
          this.backOptions = res.data;
        }
      });
    },
    onMouseOver(d) {
      console.log("onMouseOver", d)
      d.isShow = true
    },
    onMouseOut(d) {
      console.log("onMouseOut", d)
      d.isShow = false
    },
    addData(){
      addB2cBackCard(this.dialogForm).then(res=>{
        console.log(res.data);
        this.$message({message: res.data, type: 'success'});
        this.submitQueryForm();//新增之后，重新查询table
        this.handleCloseDialog();
      });
    },
    updateData(){
      updateB2cBackCard(this.dialogForm)
          .then(res => {
            this.$message({message: res.data, type: 'success'});
            this.submitQueryForm();//修改之后，重新查询table
            this.handleCloseDialog();
          })
    },
    setDefault(row){
      this.$confirm("确定设定["+row.backCardName+"]为默认银行卡?")
          .then(_ => {
            updateB2cBackCard({id:row.id,isDefault:true})
                .then(res => {
                  this.submitQueryForm();//删除之后，重新查询table
                  this.$message({message: res.data, type: 'success'});
                }).catch(err => {
              this.$message({message: err.message, type: 'error'});
            })
          });
    },
    deleteData(row){
      this.$confirm("确定删除["+row.backCardName+"]?")
          .then(_ => {
            deleteB2cBackCard(row.id)
                .then(res => {
                  this.submitQueryForm();//删除之后，重新查询table
                  this.$message({message: res.data, type: 'success'});
                }).catch(err => {
              this.$message({message: err.message, type: 'error'});
            })
          });
    },
    getData(){
      getAllB2cBackCard().then(res=>{
        console.log(res.data);
        if (res.success){
          this.setData(res.data);
        }
      });
    },
    setData(data){
      data.forEach(item=>{
        item.isShow = false;
      });
      this.cardData = data;
    },
  }
}
</script>

<style lang="scss" scoped>
.box-card {
  width: 20rem;
  height: 12rem;
  text-align: center;
}

.box-card .el-button {

}
</style>
